const actions = {
    GET_CRAWL_DOMESTIC_INDICATOR_REQUEST: "GET_CRAWL_DOMESTIC_INDICATOR_REQUEST",
    GET_CRAWL_DOMESTIC_INDICATOR_SUCCESS: "GET_CRAWL_DOMESTIC_INDICATOR_SUCCESS",
    GET_CRAWL_DOMESTIC_INDICATOR_ERROR: "GET_CRAWL_DOMESTIC_INDICATOR_ERROR",

    CRAWL_DOMESTIC_INDICATOR_REQUEST: "CRAWL_DOMESTIC_INDICATOR_REQUEST",
    CRAWL_DOMESTIC_INDICATOR_SUCCESS: "CRAWL_DOMESTIC_INDICATOR_SUCCESS",
    CRAWL_DOMESTIC_INDICATOR_ERROR: "CRAWL_DOMESTIC_INDICATOR_ERROR",

    GET_EXCEL_DOMESTIC_INDICATOR_REQUEST: "CRAWL_DOMESTIC_INDICATOR/GET_EXCEL_DOMESTIC_INDICATOR_REQUEST",
    GET_EXCEL_DOMESTIC_INDICATOR_SUCCESS: "CRAWL_DOMESTIC_INDICATOR/GET_EXCEL_DOMESTIC_INDICATOR_SUCCESS",
    GET_EXCEL_DOMESTIC_INDICATOR_ERROR: "CRAWL_DOMESTIC_INDICATOR/GET_EXCEL_DOMESTIC_INDICATOR_ERROR",

    DELETE_EXCEL_STORE_DOMESTIC_INDICATOR_REQUEST: "CRAWL_DOMESTIC_INDICATOR/DELETE_INFORMATION_STORE_DOMESTIC_INDICATOR_REQUEST",
    DELETE_EXCEL_DOMESTIC_INDICATOR_SUCCESS: "CRAWL_DOMESTIC_INDICATOR/DELETE_INFORMATION_STORE_DOMESTIC_INDICATOR_SUCCESS",
    DELETE_EXCEL_DOMESTIC_INDICATOR_ERROR: "CRAWL_DOMESTIC_INDICATOR/DELETE_INFORMATION_STORE_DOMESTIC_INDICATOR_ERROR",

    UPDATE_FORMULA_DOMESTIC_INDICATOR_REQUEST: "UPDATE_FORMULA_DOMESTIC_INDICATOR_REQUEST",
    UPDATE_FORMULA_DOMESTIC_INDICATOR_SUCCESS: "UPDATE_FORMULA_DOMESTIC_INDICATOR_SUCCESS",
    UPDATE_FORMULA_DOMESTIC_INDICATOR_ERROR: "UPDATE_FORMULA_DOMESTIC_INDICATOR_ERROR",

    crawlDomesticIndicator: (payload) => ({
        type: actions.CRAWL_DOMESTIC_INDICATOR_REQUEST,
        payload,
    }),

    getCrawlDomesticIndicator: (payload) => ({
        type: actions.GET_CRAWL_DOMESTIC_INDICATOR_REQUEST,
        payload,
    }),

    getInformationStore: () => ({
        type: actions.GET_EXCEL_DOMESTIC_INDICATOR_REQUEST,
    }),

    deleteInformationStore: (payload) => ({
        type: actions.DELETE_EXCEL_STORE_DOMESTIC_INDICATOR_REQUEST,
        payload,
    }),

    updateFormula: (payload) => ({
        type: actions.UPDATE_FORMULA_DOMESTIC_INDICATOR_REQUEST,
        payload,
    }),

};
export default actions;